/**
 * Web shape tokens for consistent border radii.
 * Keep control radius aligned with BillCard action buttons.
 */
export const shape = {
  radius: {
    control: "8px",
    card: "12px",
    modal: "16px",
    pill: "999px",
  },
};

export default shape;
